export const SET_COMMON_STATE_VARIABLE = 'SET_COMMON_STATE_VARIABLE';
export const MERGE_COMMON_STATE_VARIABLE = 'MERGE_COMMON_STATE_VARIABLE';
export const SET_XCONNECT_CALLBACK_ID = 'SET_XCONNECT_CALLBACK_ID';
export const SEND_SIGNAL = 'SEND_SIGNAL';
export const REMOVE_SIGNAL = 'REMOVE_SIGNAL';

export const reduxTools = {
  sendSignal: (signalId, payload) => {
    return dispatch => {
      dispatch({
        type: SEND_SIGNAL,
        signalId: signalId,
        signalReducer: () => {
          dispatch({ type: REMOVE_SIGNAL, signalId });
          return payload;
        }
      });
    };
  },

  set: (path, value, callbackIds) => {
    return { type: SET_COMMON_STATE_VARIABLE, path, value, callbackIds };
  },

  merge: (path, obj, callbackIds) => {
    return { type: MERGE_COMMON_STATE_VARIABLE, path, obj, callbackIds };
  },

  createAction: (action, payload, callBackId) => {
    return dispatch => {
      dispatch({ type: action, payload });
      if (callBackId) {
        dispatch({ type: SET_XCONNECT_CALLBACK_ID, callBackId });
      }
    };
  }
};
